// extracted by mini-css-extract-plugin
export var statItem = "_iw-1";
export var statsRow = "_iw-0";